import { atom } from "recoil";
import { OptionType } from "../api/types";

export const optionsResState = atom<any>({
  key: "optionsRes",
  default: null,
});
